import { useState } from "react";
import "../clients/ClientTable.css";
export default function TypesEntretienTable({entretiens, onEdit, onDelete }) {
   const [search, setSearch] = useState("");
   const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // nombre par page

   // 🔍 Filtrage
  // const filteredClients = clients.filter(client =>
  //   client.nom?.toLowerCase().includes(search.toLowerCase()) ||
  //   client.email?.toLowerCase().includes(search.toLowerCase())
  // );
  const filteredEntretiens =(entretiens || []).filter(t => {
  const q = (search || "").toLowerCase();
  return (
    (t?.nom || "").toLowerCase().includes(q) ||
    (t?.description || "").toLowerCase().includes(q)
  );
});

const totalPages = Math.ceil(filteredEntretiens.length / itemsPerPage);

const startIndex = (currentPage - 1) * itemsPerPage;
const endIndex = startIndex + itemsPerPage;

const paginatedEntretiens = filteredEntretiens.slice(startIndex, endIndex);
  return (
  <div className="table-container">

      {/* Champ recherche */}
      <input
        type="text"
        placeholder="Rechercher par Type ..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ padding: "8px", width: "100%", marginBottom: "15px" }}
      />
      {filteredEntretiens.length === 0 ? (
        <p>Aucun Types EntretienS trouvé</p>
      ) : ( <table className="responsive-table">
      <thead>
        <tr>
          <th>Nom</th>
          <th>description</th>                   
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {paginatedEntretiens.map((c) => (
       
          <tr key={c.id}>
            <td data-label="Type D'entretien">{c.nom}</td>
            <td data-label="Description">{c.description}</td>
                  
            <td data-label="Actions">
              <button className="btn edit" onClick={() => onEdit(c)}>✏️</button>
              <button className="btn delete" onClick={() => onDelete(c.id)}>🗑</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
   )}

   <div className="pagination">
  <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage(currentPage - 1)}
  >
    ◀
  </button>

  {Array.from({ length: totalPages }, (_, i) => (
    <button
      key={i}
      className={currentPage === i + 1 ? "active" : ""}
      onClick={() => setCurrentPage(i + 1)}
    >
      {i + 1}
    </button>
  ))}

  <button
    disabled={currentPage === totalPages}
    onClick={() => setCurrentPage(currentPage + 1)}
  >
    ▶
  </button>
</div>

  </div>
  

  );
}
